module.exports = __webpack_public_path__ + "static/media/loc1_img17.1348189b.jpg";